import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { RateCardGridModule } from './rate-card-grid.module';
import { RateCardComponent } from './rate-cards.component';

const routes: Routes = [{ path: '', component: RateCardComponent, data: { title: 'Rate Cards' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RateCardsRoutingModule {}

@NgModule({
  imports: [
    RateCardsRoutingModule,
    RateCardGridModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [RateCardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RateCardsModule {}
